import { AuthConfig, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from './../../environments/environment';

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [ environment.offerApiUrl, environment.catalogApiUrl ],
    sendAccessToken: true,
  }
};

export const DiscoveryDocumentConfig = {
  url : `https://${environment.tenant}.b2clogin.com/${environment.tenant}.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_ForcePasswordReset_SignIn`,
};

export const resetPasswordUrl = `https://${environment.tenant}.b2clogin.com/${environment.tenant}.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_PasswordReset&client_id=${environment.clientId}&nonce=defaultNonce&redirect_uri=${environment.redirectUrl}&scope=openid&response_type=code&prompt=login`;

export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: `https://${environment.tenant}.b2clogin.com/${environment.tenantId}/v2.0/`,

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin,

  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',

  responseType: 'code',

  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  // The api scope is a usecase specific one
  scope: `openid offline_access https://${environment.tenant}.onmicrosoft.com/${environment.apiScope}`,

  // The SPA's id. The SPA is registerd with this id at the auth-server
  // clientId: 'server.code',
  clientId: environment.clientId,
  tokenEndpoint: `https://${environment.tenant}.b2clogin.com/${environment.tenant}.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1a_forcepasswordreset_SignIn`,
  // loginUrl: 'https://agilecoreww001.b2clogin.com/f8fc6767-abfc-4f5b-941f-620ad505a16f/oauth2/v2.0/token?p=b2c_1a_forcepasswordreset_SignIn',

  // URL of the SPA to redirect the user after silent refresh
  silentRefreshRedirectUri: window.location.origin + '/silent-renew.html',

  // defaults to true for implicit flow and false for code flow
  // as for code code the default is using a refresh_token
  // Also see docs section 'Token Refresh'
  useSilentRefresh: true,

  showDebugInformation: true,
  strictDiscoveryDocumentValidation: false,
  // skipIssuerCheck: true,
  // clearHashAfterLogin: true,
  // oidc: true,
};
